import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FcprogressbarComponent } from './fcprogressbar.component';
import { FcprogresscircleComponent } from './fcprogresscircle.component';
import { FcprogresspercentComponent } from './fcprogresspercent.component';
import { FcshareModule } from '../fcshare.modal';
@NgModule({
  imports: [
    FcshareModule
  ],
  exports: [
    FcprogressbarComponent,
    FcprogresscircleComponent,
    FcprogresspercentComponent   
  ],
  declarations: [
    FcprogressbarComponent,
    FcprogresscircleComponent,
    FcprogresspercentComponent  
  ],
  providers: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class FcprogressModule { }